var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m2.40002 13.6c0-.4419.35818-.8.8-.8h9.59998c.4419 0 .8.3581.8.8 0 .4418-.3581.8-.8.8h-9.59998c-.44182 0-.8-.3582-.8-.8zm2.63432-6.16571c.31242-.31242.81895-.31242 1.13137 0l1.03431 1.03431v-6.06862c0-.44183.35818-.8.8-.8.44183 0 .8.35817.8.8v6.06863l1.03432-1.03432c.31246-.31242.81896-.31242 1.13136 0s.3124.81895 0 1.13137l-2.39999 2.40004c-.15003.15-.35351.2343-.56569.2343-.21217 0-.41565-.0843-.56568-.2343l-2.4-2.40004c-.31242-.31242-.31242-.81895 0-1.13137z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.dc4afa670f68ff1ad0f69f18cecd802d.svg";
export { ForwardRef as ReactComponent };